export interface LPFRProps {
  first_name: string;
  last_name: string;
  dni: string;
  cuit: string;
}

export const getLPFilterRequest = (event: LPFRProps) => {
  return {
    ...(event?.first_name
      ? {
          Nombre: event?.first_name,
        }
      : {}),
    ...(event?.last_name
      ? {
          Apellido: event?.last_name,
        }
      : {}),
    ...(event?.dni
      ? {
          dni: event?.dni,
        }
      : {}),

    ...(event?.cuit
      ? {
          Cuit: event?.cuit,
        }
      : {}),
  };
};
